var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_967_16671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9831 0.888672C9.48128 0.888672 0.888916 9.48867 0.888916 19.9998C0.888916 30.5109 9.48128 39.1109 19.9831 39.1109C30.4848 39.1109 39.0772 30.5109 39.0772 19.9998C39.0772 9.48867 30.5803 0.888672 19.9831 0.888672ZM28.7664 28.5042C28.3845 29.0776 27.7162 29.2687 27.1434 28.8864C22.6562 26.1153 17.0235 25.542 10.3405 27.0709C9.67222 27.262 9.09939 26.7842 8.90845 26.2109C8.71751 25.542 9.19487 24.9687 9.76769 24.7776C17.0235 23.1531 23.3245 23.822 28.289 26.8798C28.9573 27.1665 29.0528 27.9309 28.7664 28.5042ZM31.0577 23.2487C30.5803 23.9176 29.7211 24.2042 29.0528 23.7264C23.8974 20.5731 16.0688 19.6176 10.0541 21.5287C9.29034 21.7198 8.4311 21.3376 8.24016 20.5731C8.04922 19.8087 8.4311 18.9487 9.19487 18.7576C16.1642 16.6553 24.7566 17.7064 30.6758 21.3376C31.2486 21.6242 31.535 22.5798 31.0577 23.2487ZM31.2486 17.8976C25.1385 14.2664 14.9231 13.8842 9.09939 15.6998C8.14469 15.9864 7.18998 15.4131 6.90357 14.5531C6.61716 13.5976 7.18998 12.642 8.04922 12.3553C14.8276 10.3487 25.9977 10.7309 33.0625 14.9353C33.9218 15.4131 34.2082 16.5598 33.7308 17.4198C33.2535 18.0887 32.1078 18.3753 31.2486 17.8976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_967_16671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.d4d8bd286ee6436b5d5605ff68c7225d.svg";
export { ForwardRef as ReactComponent };